import { render, staticRenderFns } from "./AzureAuth.vue?vue&type=template&id=aa3c9a1e&"
import script from "./AzureAuth.vue?vue&type=script&lang=js&"
export * from "./AzureAuth.vue?vue&type=script&lang=js&"
import style0 from "./AzureAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports